import { createSlice } from "@reduxjs/toolkit";
import { CampaignSliceType } from "src/types/campaign";
import { getCampaignTypes, getChannels } from "../campaign/thunk";

const initialState: CampaignSliceType = {
  channelList: [],
  campaignTypeList: [],
};

export const campaignSlice = createSlice({
  name: "campaign",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getChannels.fulfilled, (state, { payload }) => {
      state.channelList = payload;
    });
    builder.addCase(getCampaignTypes.fulfilled, (state, { payload }) => {
      state.campaignTypeList = payload;
    });
  },
});

export const campaignReducer = campaignSlice.reducer;
